// Explicit deltas must never be deduplicated: repeated tokens can be legitimate.
export function getStreamTextMode(eventName, payload) {
  const names = [eventName, payload?.event, payload?.type, payload?.kind].filter(Boolean);
  if (typeof payload?.choices?.[0]?.delta?.content === "string" ||
      typeof payload?.delta === "string" || typeof payload?.token === "string" ||
      names.some(name => /(^|[._-])delta($|[._-])/i.test(name))) return "delta";
  if (typeof payload?.assistant_message === "string" || typeof payload?.assistantMessage === "string" ||
      typeof payload?.choices?.[0]?.message?.content === "string" ||
      names.some(name => /^(final|complete|completion|snapshot|response\.text|response\.text\.done|response\.done)$/i.test(name))) return "snapshot";
  return "legacy";
}

export function mergeStreamText(currentText, incomingText, mode = "legacy") {
  if (!incomingText) return currentText;
  if (mode === "snapshot") return incomingText;
  if (mode === "delta") return currentText + incomingText;
  if (!currentText || incomingText.startsWith(currentText)) return incomingText;
  return currentText + incomingText;
}
